import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  contactsContainer: {
    display: "flex",
    alignItems: "center",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  contactItem: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
    color: "#FFFFFF",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    "@media (max-width: 1200px)": {
      "&[href^='mailto:']": {
        textDecoration: "underline !important"
      }
    },
    "&:hover": {
      textDecoration: "underline"
    },
    "& + $contactItem": {
      marginLeft: 32,
      "@media (max-width: 600px)": {
        marginLeft: 0,
        marginTop: 12
      }
    }
  }
});
